import styles from "./QnaArticle.module.css";

export default function QnaInquiry(props) {
  let data = props.data;

  return (
    <div className={styles.QnaArticle}>
      <div className={styles.Article}>
        <div className={styles.TitleDiv}>
          <div className={styles.Title}>{data.title}</div>
          <div className={styles.Date}>{data.date}</div>
        </div>
        <div className={styles.UserInfo}>
          <div>
            <div className={styles.Label}>작성자</div>
            <div>{data.user_name}</div>
          </div>
          <div>
            <div className={styles.Label}>이메일</div>
            <div>{data.user_email}</div>
          </div>
          <div>
            <div className={styles.Label}>전화번호</div>
            <div>{data.user_tel}</div>
          </div>
        </div>
        <div className={styles.Content}>{data.content}</div>
      </div>
    </div>
  );
}
